export enum AppVersionStatus
{
  Ok = 'ok',
  Hard = 'hard',
  Soft = 'soft',
}

export interface IVersionCheckResult
{
  status: AppVersionStatus;
  soft_version: number;
}

export type AppVersionThresholds = {
  hard: number;
  soft: number;
};

export type AppVersionPolicyInput = {
  platform: string;
  build: number;
  thresholds: AppVersionThresholds;
  soft_dismissed: boolean;
};

export const NATIVE_PLATFORMS: ReadonlySet<string> = new Set( [ 'android', 'ios' ] );

export function isUpdateCheckedPlatform( platform: string ): boolean
{
  return NATIVE_PLATFORMS.has( platform );
}

export function resolveAppVersionStatus( input: AppVersionPolicyInput ): IVersionCheckResult
{
  const ok: IVersionCheckResult = { status: AppVersionStatus.Ok, soft_version: 0 };

  if ( !isUpdateCheckedPlatform( input.platform ) )
    return ok;

  if ( !( input.build > 0 ) )
    return ok;

  const { hard, soft } = input.thresholds;

  if ( hard > 0 && input.build < hard )
    return { status: AppVersionStatus.Hard, soft_version: 0 };

  if ( soft > 0 && input.build < soft )
  {
    if ( input.soft_dismissed )
      return { status: AppVersionStatus.Ok, soft_version: soft };

    return { status: AppVersionStatus.Soft, soft_version: soft };
  }

  return ok;
}
